import { getCookie } from '@agendapro/sapphire';
import axios from 'axios';
import { camelizeKeys, decamelizeKeys } from 'humps';

import { ENV } from '@/config/env';

export const AP_API =
  process.env.NODE_ENV === 'test'
    ? axios
    : axios.create({
        baseURL: ENV.AP_API_URL,
        timeout: 60000,
        headers: {
          'Content-Type': 'application/json',
          ...(typeof window !== 'undefined' ? { Authorization: getCookie('ap_cognito_authorization') } : undefined),
        },
      });

AP_API.interceptors.request.use(
  (config) => {
    const newConfig = { ...config };

    if (newConfig.headers && newConfig.headers['Content-Type'] === 'multipart/form-data') {
      return newConfig;
    }
    if (config.params) {
      newConfig.params = decamelizeKeys(config.params);
    }
    if (config.data) {
      newConfig.data = decamelizeKeys(config.data);
    }
    return newConfig;
  },
  (error) => Promise.reject(error),
);

AP_API.interceptors.response.use(
  (response) => {
    if (response.data && response.headers['content-type'].includes('application/json')) {
      response.data = camelizeKeys(response.data);
    }

    return response;
  },
  (error) => Promise.reject(error),
);
